import styled from 'styled-components';

export const ButtonActive = styled.button`
  width: 327px;
  height: 56px;
  border-radius: 32px;
  border: none;
  color: #1b1b1b;
  background: #BF9663;
  margin-bottom: 24px;
  cursor: pointer;
  outline: 0;
`;

export const ButtonDisabled = styled.button`
  width: 327px;
  height: 56px;
  border-radius: 32px;
  border: none;
  color: #2b2b2b;
  background: #a39483;
  margin-bottom: 24px;
  outline: 0;
`;
